import * as React from "react";
import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";

import Drawer from "@mui/material/Drawer";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";

import { useNavigate } from "react-router";
import SerinLogo from "../images/serin-logo.png";
import {
  CommunicationsIcon,
  CommunicationsWhiteIcon,
  CultureIndexIcon,
  LearningIcon,
  DEI,
  ProfileIcon,
  ProfileWhiteIcon,
  PsychologicalICON,
} from "../icons/Icons";
import classes from "./Sidebar.module.css";

import SidebartoolTip from "./namePopTop";

import "./sidebartool.css";
import { DrawerContext } from "../../utilities/context/DrawerProvider";

import { uirole } from "../../roles";
import { getCookie, getCookieFromServer, getLocalStorage } from "../../Cookies";

const style = {
  position: "relative",
  top: "0%",
  left: "90%",
  // transform: "translate(-50%, -50%)",
  width: 110,

  zIndex: 22,
  color: "#666666",
  borderRadius: "10px",

  fontSize: "12px",
  fontFamily: "Poppins",
};

const drawerWidth = 160;

// Equation
// Evolve
// Progress Report
// DEI Calendar
// Profile
function ResponsiveDrawer(props) {
  const { window, sidebar } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const { rolesAndPermission, setRolesAndPermission } = React.useContext(DrawerContext);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  React.useEffect(() => {
    console.log(rolesAndPermission);
    if (!rolesAndPermission) {
      uirole(
        getCookieFromServer("bearer")
          ? getCookieFromServer("bearer")
          : getLocalStorage("bearer")
      )
        .then((res) => {
          setRolesAndPermission(res);
        })
        .catch((err) => { });
    }
  }, [rolesAndPermission]);


  const navigate = useNavigate();

  const profileRef = React.useRef()

  React.useEffect(() => {
    if (profileRef.current && sidebar === "Profile") {
      profileRef.current.scrollIntoView({ behaviour: "smooth", inline: "end" })
    }
  }, [sidebar, profileRef])

  const drawer = (
    <div className="HrSidebar">
      <Box
        className="StickMenuLogo"
        onClick={() => {
          navigate("/hr/Learning");
        }}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "60px 0px",
          "&:hover": {
            cursor: "pointer",
          },
        }}
      >
        <img src={SerinLogo} alt="" />
      </Box>
      <List>
        {rolesAndPermission?.DEI?.viewPermission && (
          <ListItem
            className="tooltip-wrap"
            key={"hr"}
            disablePadding
            onClick={() => {
              navigate("/hr");
            }}
            sx={{
              mb: "30px",
            }}
          >
            <ListItemButton
              sx={{
                opacity: sidebar == "HomePageHr" ? "1" : "0.6",
                "&:hover": {
                  opacity: "1"
                }
              }}
              className={classes.navBtn}
            >
              <ListItemIcon
                className={classes.navIcon}
                sx={{
                  backgroundColor:
                    sidebar == "HomePageHr" && "rgba(119, 88, 204, 0.8)",
                }}
              >
                <CultureIndexIcon />
              </ListItemIcon>
            </ListItemButton>
            <Box sx={style} className="tooltip-content">
              <SidebartoolTip name={"Diversity"} />
            </Box>
          </ListItem>
        )}
        {rolesAndPermission?.Psycological_Study?.viewPermission && (
          <ListItem
            className="tooltip-wrap"
            key={"hr"}
            disablePadding
            onClick={() => {
              navigate("/hr/Psychological_safety");
            }}
            sx={{
              mb: "30px",
            }}
          >
            <ListItemButton
              sx={{
                opacity: sidebar == "Psycho_Bystand" ? "1" : "0.6",
                "&:hover": {
                  opacity: "1"
                }
              }} className={classes.navBtn}>
              <ListItemIcon
                className={classes.navIcon}
                sx={{
                  backgroundColor:
                    sidebar == "Psycho_Bystand" && "rgba(119, 88, 204, 0.7)",
                }}
              >
                <PsychologicalICON />
              </ListItemIcon>
            </ListItemButton>
            <Box sx={style} className="tooltip-content">
              <SidebartoolTip name={"Inclusion"} />
            </Box>
          </ListItem>
        )}
        
        {rolesAndPermission?.Learning?.viewPermission && (
          <ListItem
            className="tooltip-wrap"
            key={"Learning"}
            disablePadding
            onClick={() => {
              navigate("/hr/Learning");
            }}
            sx={{ mb: "30px" }}
          >
            <ListItemButton
              sx={{
                opacity: sidebar == "Learning" ? "1" : "0.6",
                "&:hover": {
                  opacity: "1"
                }
              }} className={classes.navBtn}>
              <ListItemIcon
                className={classes.navIcon}
                sx={{
                  backgroundColor:
                    sidebar == "Learning" && "rgba(119, 88, 204, 0.7)",
                }}
              >
                <LearningIcon />
              </ListItemIcon>
            </ListItemButton>
            <Box sx={style} className="tooltip-content">
              <SidebartoolTip name={"Learning"} />
            </Box>
          </ListItem>
        )}

        {rolesAndPermission?.Report?.viewPermission && (
          <ListItem
            className="tooltip-wrap"
            key={"GroupReport"}
            disablePadding
            onClick={() => {
              navigate("/hr/GroupReport");
            }}
            sx={{ mb: "30px" }}
          >
            <ListItemButton
              sx={{
                opacity: sidebar == "GroupReport" ? "1" : "0.6",
                "&:hover": {
                  opacity: "1"
                }
              }} className={classes.navBtn}>
              <ListItemIcon
                className={classes.navIcon}
                sx={{
                  backgroundColor:
                    sidebar == "GroupReport" && "rgba(119, 88, 204, 0.7)",
                }}
              >
                {sidebar == "GroupReport" ? (
                  <CommunicationsWhiteIcon />
                ) : (
                  <CommunicationsIcon />
                )}
              </ListItemIcon>
            </ListItemButton>

            <Box sx={{
              position: "relative",
              top: "100%",
              left: "25%",
              // transform: "translate(-5%, -50%)",
              width: "125px",
              zIndex: 22,
              color: "#666666",
              borderRadius: "10px",

              fontSize: "12px",
              fontFamily: "Poppins",
            }}
              className="tooltip-content">
              <SidebartoolTip
                width={"125px"}
                name={"Progress report"}
              />
            </Box>
          </ListItem>
        )}

        {rolesAndPermission?.Calender?.viewPermission && (
          <ListItem
            className="tooltip-wrap"
            key={"DEI"}
            disablePadding
            onClick={() => {
              navigate("/hr/DEI");
            }}
            sx={{ mb: "30px" }}
          >
            <ListItemButton
              sx={{
                opacity: sidebar == "DEI" ? "1" : "0.6",
                "&:hover": {
                  opacity: "1"
                }
              }} className={classes.navBtn}>
              <ListItemIcon
                className={classes.navIcon}
                sx={{
                  backgroundColor:
                    sidebar == "DEI" && "rgba(119, 88, 204, 0.7)",
                }}
              >
                <DEI />
              </ListItemIcon>
            </ListItemButton>

            <Box sx={style} className="tooltip-content">
              <SidebartoolTip name={"DEI Calendar"} />
            </Box>
          </ListItem>
        )}

        {rolesAndPermission?.Profile?.viewPermission && (
          <ListItem
            className="tooltip-wrap"
            key={"Profile"}
            disablePadding
            onClick={() => {
              navigate("/hr/HrProfilePage");
            }}
            sx={{ mb: "30px" }}
            ref={profileRef}
          >
            <ListItemButton
              sx={{
                opacity: sidebar == "Profile" ? "1" : "0.6",
                "&:hover": {
                  opacity: "1"
                }
              }} className={classes.navBtn}>
              <ListItemIcon
                className={classes.navIcon}
                sx={{
                  backgroundColor:
                    sidebar == "Profile" && "rgba(119, 88, 204, 0.7)",
                }}
              >
                {sidebar == "Profile" ? <ProfileWhiteIcon /> : <ProfileIcon />}
              </ListItemIcon>
            </ListItemButton>
            <Box sx={style} className="tooltip-content">
              <SidebartoolTip name={"Profile"} />
            </Box>
          </ListItem>
        )}
      </List>
      {/* <List>
        {['All mail', 'Trash', 'Spam'].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List> */}
    </div >
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      {/* <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
        
        </Toolbar>
      </AppBar> */}
      <Box
        // data-aos="fade-right"
        // data-aos-duration="1500"
        className={classes.dashboardAnime}
        component="nav"
        sx={{
          width: { sm: drawerWidth },
          flexShrink: { sm: 0 },
        }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        {/* <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer> */}
        <Drawer
          variant="permanent"
          className="HideScrollbar"
          PaperProps={{ className: "HrSidebar" }}
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              backgroundColor: "#6846C7",
              height: "95vh",
              borderRadius: "24px",
              margin: "24px",
              // scrollbarWidth: "10px"
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      {/* <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
      >
        <Toolbar />
        <Typography paragraph>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
          tempor incididunt ut labore et dolore magna aliqua. Rhoncus dolor purus non
          enim praesent elementum facilisis leo vel. Risus at ultrices mi tempus
          imperdiet. Semper risus in hendrerit gravida rutrum quisque non tellus.
          Convallis convallis tellus id interdum velit laoreet id donec ultrices.
          Odio morbi quis commodo odio aenean sed adipiscing. Amet nisl suscipit
          adipiscing bibendum est ultricies integer quis. Cursus euismod quis viverra
          nibh cras. Metus vulputate eu scelerisque felis imperdiet proin fermentum
          leo. Mauris commodo quis imperdiet massa tincidunt. Cras tincidunt lobortis
          feugiat vivamus at augue. At augue eget arcu dictum varius duis at
          consectetur lorem. Velit sed ullamcorper morbi tincidunt. Lorem donec massa
          sapien faucibus et molestie ac.
        </Typography>
        <Typography paragraph>
          Consequat mauris nunc congue nisi vitae suscipit. Fringilla est ullamcorper
          eget nulla facilisi etiam dignissim diam. Pulvinar elementum integer enim
          neque volutpat ac tincidunt. Ornare suspendisse sed nisi lacus sed viverra
          tellus. Purus sit amet volutpat consequat mauris. Elementum eu facilisis
          sed odio morbi. Euismod lacinia at quis risus sed vulputate odio. Morbi
          tincidunt ornare massa eget egestas purus viverra accumsan in. In hendrerit
          gravida rutrum quisque non tellus orci ac. Pellentesque nec nam aliquam sem
          et tortor. Habitant morbi tristique senectus et. Adipiscing elit duis
          tristique sollicitudin nibh sit. Ornare aenean euismod elementum nisi quis
          eleifend. Commodo viverra maecenas accumsan lacus vel facilisis. Nulla
          posuere sollicitudin aliquam ultrices sagittis orci a.
        </Typography>
      </Box> */}
    </Box>
  );
}

ResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default ResponsiveDrawer;
